function a(n, t, r) {
  for (var e = 0, u = r.length; e < u; ) {
    if (n(t, r[e]))
      return !0;
    e += 1;
  }
  return !1;
}
export {
  a as default
};
